export const maintenanceStatuses = {
  inProgress: 'maintenanceInProgress',
  inFiveMinutes: 'maintenanceIn5',
  inFifteenMinutes: 'maintenanceIn15',
  withinHour: 'maintenanceInHour',
  withinDay: 'maintenanceInDay',
  notScheduled: 'noMaintenance',
};

export const maintenanceTimeInMinutes = 15;
